import { Controller } from "@hotwired/stimulus"

// Books Entrance Controller
// Handles staggered entrance animations for book cards
export default class extends Controller {
  connect() {
    // Trigger animation by adding a class or manipulating animation state
    // The CSS handles the actual animation
    
    // Optional: Use IntersectionObserver for viewport-triggered animations
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.animationPlayState = 'running'
            }
          })
        },
        {
          threshold: 0.1,
          rootMargin: '50px'
        }
      )
      
      // Observe all book cards
      const bookCards = this.element.closest('.row')?.querySelectorAll('.book-card')
      if (bookCards) {
        bookCards.forEach((card) => {
          // Initially pause animations until they're in viewport
          card.style.animationPlayState = 'paused'
          this.observer.observe(card)
        })
      }
    }
  }
  
  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
